module.exports = __webpack_public_path__ + "125eb627906659a5a7352d68bddac1b0.png";